// @flow

export const COMMUNICATIONS_IN_PROGRESS = "COMMUNICATIONS_IN_PROGRESS";
export const COMMUNICATIONS_ERROR = "COMMUNICATIONS_ERROR";
export const COMMUNICATIONS_SUCCESS = "COMMUNICATIONS_SUCCESS";

export function communicationsInProgress(id: string) {
  return { type: COMMUNICATIONS_IN_PROGRESS, id };
}

export function communicationsError(id: string, error: Error | {}) {
  return { type: COMMUNICATIONS_ERROR, id, error };
}

export function communicationsSuccess(id: string) {
  return { type: COMMUNICATIONS_SUCCESS, id };
}
